import { defineStyleConfig } from "@chakra-ui/react";

const Avatar = defineStyleConfig({
  // The styles all button have in common
  baseStyle: {
    container: {
      border: "1px solid var(--chakra-colors-secondary-400)",
      background: "secondary.600",
    },
  },
});

export default Avatar;
